import CarouselImage, { Image as _Image } from './CarouselImage';
export default CarouselImage;
export type Image = _Image;
